module.exports = __webpack_public_path__ + "static/media/shopware6_certified_template_designer.bf69b354.svg";